'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _pure = require('recompose/pure');

var _pure2 = _interopRequireDefault(_pure);

var _SvgIcon = require('material-ui/SvgIcon');

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SvgIconCustom = global.__MUI_SvgIcon__ || _SvgIcon2.default;

var _ref = _react2.default.createElement('path', { d: 'M14 5h8v2h-8zm0 5.5h8v2h-8zm0 5.5h8v2h-8zM2 11.5C2 15.08 4.92 18 8.5 18H9v2l3-3-3-3v2h-.5C6.02 16 4 13.98 4 11.5S6.02 7 8.5 7H12V5H8.5C4.92 5 2 7.92 2 11.5z' });

var LowPriority = function LowPriority(props) {
  return _react2.default.createElement(
    SvgIconCustom,
    props,
    _ref
  );
};

LowPriority = (0, _pure2.default)(LowPriority);
LowPriority.muiName = 'SvgIcon';

exports.default = LowPriority;


//////////////////
// WEBPACK FOOTER
// ./~/material-ui-icons/LowPriority.js
// module id = 2600
// module chunks = 0